var _defs, _circle, _g, _g2;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgCloseMenuDark = function SvgCloseMenuDark(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".close-menu-dark-a{fill:#fff;opacity:0.05;}.close-menu-dark-b{fill:none;stroke:#fff;stroke-width:2px;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "close-menu-dark-a",
    cx: 22.5,
    cy: 22.5,
    r: 22.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.436 14.436) rotate(45)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "close-menu-dark-b",
    d: "M0,0H17.082",
    transform: "translate(0 2.863)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(30.514 18.485) rotate(135)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "close-menu-dark-b",
    d: "M0,0H17.082",
    transform: "translate(0 2.863)"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCloseMenuDark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/close-menu-dark.2bf01bcf.svg";
export { ForwardRef as ReactComponent };